import i18n from '../i18n';

export const getSegmentsCountText = (number) => {
  if (Number.isInteger(number)) {
    if (number === 0) {
      return i18n.t('common:Nonstop');
    } else if (number === 1) {
      return `${number} ${i18n.t('common:Stop')}`;
    } else if (number > 1) {
      return `${number} ${i18n.t('common:Stops')}`;
    }
  }
  return ' ';
};
